import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NzMessageService} from "ng-zorro-antd/message";
import {TranslateService} from "@root/shared/service/translate.service";
import {HttpClient} from "@angular/common/http";
import {ModalService} from "@root/router/index/modal.service";
import {NzModalService} from "ng-zorro-antd/modal";
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
  selector: 'host-widget-deposit',
  templateUrl: 'deposit.component.html',
  styleUrls: ['deposit.component.scss']
})

export class WidgetDepositComponent implements OnInit {
  _depositDetail;

  @Input() reservationCode;
  @Input()
  get depositDetail() {
    return this._depositDetail;
  }
  set depositDetail(value) {
    if (value) {
      this._depositDetail = value;
      this.setForm.patchValue({ deposit: value.receivable });
      this.deductForm.patchValue({ wait_deducted_deposit: value.deducted || 0 });
    }
  }
  @Output() onSuccess = new EventEmitter();
  setForm: FormGroup = this.fb.group({
    deposit: null,
  });

  deductForm: FormGroup = this.fb.group({
    wait_deducted_deposit: null
  });

  get waitDeductedDeposit () {
    return this.deductForm.get('wait_deducted_deposit').value || 0;
  }

  constructor(
    private msg: NzMessageService,
    private t: TranslateService,
    private http: HttpClient,
    private modal: NzModalService,
    private globalModalSrv: ModalService,
    private fb: FormBuilder
  ) {
  }

  ngOnInit() {
  }

  requestSetDeposit() {
    const deposit = this.setForm.get('deposit').value;
    console.log('current deposit: ', deposit)
    const params = {
      reservation_code: this.reservationCode,
      type: 6,
      deposit: deposit
    };
    this.http.post('/api/reservation/set_guide', params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        // this.messageService.success('押金已设置');
        this.msg.success(
          this.t.syncGet('reservation.detail.deposit.toast.set_success')
        );
        this.onSuccess.emit();
      }
    });
  }

  requestDeduct () {
    if (this.waitDeductedDeposit < 0) {
      // return this.messageService.warning('不可输入负数');
      return this.msg.warning(
        this.t.syncGet('reservation.detail.deposit.toast.negative_waring')
      );
    }

    const params = {
      reservation_code: this.reservationCode,
      amount: this.waitDeductedDeposit
    };
    this.http.post('/api/deposit/deduct', params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.onSuccess.emit();
      }
    });
  }

  requestRefund () {
    this.http.post('/api/deposit/refund', { reservation_code: this.reservationCode}).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(
          this.t.syncGet('reservation.detail.deposit.toast.deduct_success')
        );
        this.onSuccess.emit();
      }
    });
  }

  displayDepositModal () {
    this.globalModalSrv.displayDepositModal();
  }

  displayDeductDepositModal (tpl) {
    // this.depositDetail.waitDeductedDeposit = this.depositDetail.deducted || 0;
    // this.deductForm.patchValue({ wait_deducted_deposit:  });
    this.modal.create({
      // nzTitle: '扣押金',
      nzTitle: this.t.syncGet('reservation.detail.deposit.modal.deduct_title'),
      nzContent: tpl,
      // nzOkText: '保存',
      nzOkText: this.t.syncGet('word.save'),
      nzOnOk: () => this.requestDeduct()
    });
  }

  displayRefundDepositModal () {
    this.modal.confirm({
      // nzTitle: '确认立即退还押金？',
      nzTitle: this.t.syncGet('reservation.detail.deposit.confirm.refund_title'),
      // nzContent: `即将退还押金${this.depositDetail.pending_refund}`,
      nzContent: this.t.syncGet('reservation.detail.deposit.confirm.refund_content', {
        number: this.depositDetail.pending_refund
      }),
      nzOnOk: () => this.requestRefund()
    });
  }
}
